export enum RegionId {
  None = 0,
  Norway = 1,
  Sweden = 2,
  Denmark = 3,
  Finland = 4,
  Germany = 5,
  Spain = 6,
}
